import { Injectable } from "@angular/core";
import { LoggerService } from "@app/logger/logger.service";
import { environment } from "@env/environment";

const log = new LoggerService('HOME SERVICE');


@Injectable({ providedIn: "root" })
export class HomeService {

  constructor() { }

  public async getHomeNavigationData() {
    const idToken = localStorage.getItem('idToken');
    const fetchResponse = await fetch(`${environment.EPIONE_API}/epione-core-api/home`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      }
    });
    const apiResponse: Utils.ApiResponse<Entities.Organization.OrganizationData> = await fetchResponse.json();
    //log.debug('[editOrganization] API Response: ', apiResponse);
    return apiResponse;
  }
  
}